<template>
    <ReactPage>
        <just-scan-report-page></just-scan-report-page>
    </ReactPage>
</template>

<script>
import ReactPage from '../components/ReactPage.vue';

export default {
    name: "JustScanReport",
    components: {
        ReactPage
    }
}
</script>
